export const EMBEDDED_REDIRECT_RETURN = 'embeddedRedirectReturn';

export const escapeNestedCashier = (): boolean => {
  try {
    if (window.parent === window) return false;

    const parentDocument = window.parent.document;

    if (!parentDocument.querySelector('.panoramic-2-0-theme')) return false;
    if (!parentDocument.getElementById('embedded-redirect-iframe')) return false;

    window.parent.postMessage(
      JSON.stringify({ [EMBEDDED_REDIRECT_RETURN]: true }),
      window.location.origin,
    );

    return true;
  } catch (e) {
    return false;
  }
};
